import { render, staticRenderFns } from "./x-searchbox.component.vue?vue&type=template&id=2182609a&scoped=true"
import script from "./x-searchbox.component.vue?vue&type=script&lang=ts"
export * from "./x-searchbox.component.vue?vue&type=script&lang=ts"
import style0 from "./x-searchbox.component.vue?vue&type=style&index=0&id=2182609a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182609a",
  null
  
)

export default component.exports